import { Team__Joeles } from "../teams/Joeles";
import { Team__Adrianes } from "../teams/Adrianes";
import { Team__PecanBros } from "../teams/PecanBros";
import { Team__FlintTropics } from "../teams/FlintTropics";
import { Team__Llamas } from "../teams/Llamas";
import { Team__UTPaquime } from "../teams/UTPaquime";
import { Team__DublanCity } from "../teams/DublanCity";
import { Team__IrrigacionAgricola } from "../teams/IrrigacionAgricola";
import { Team__Potros } from "../teams/Potros";
import { Team__Pistons } from "../teams/Pistons";

const Joeles = {
  team: Team__Joeles,
  playingPlayers: [],

  goals: 37,
  penaltyGoals: 0,
  isWinner: false,
};

const Adrianes = {
  team: Team__Adrianes,
  playingPlayers: [],

  goals: 25,
  penaltyGoals: 0,
  isWinner: false,
};

const PecanBros = {
  team: Team__PecanBros,
  playingPlayers: [],

  goals: 32,
  penaltyGoals: 0,
  isWinner: false,
};

const FlintTropics = {
  team: Team__FlintTropics,
  playingPlayers: [],

  goals: 27,
  penaltyGoals: 0,
  isWinner: false,
};

const Llamas = {
  team: Team__Llamas,
  playingPlayers: [],

  goals: 42,
  penaltyGoals: 0,
  isWinner: false,
};

const UTPaquime = {
  team: Team__UTPaquime,
  playingPlayers: [],

  goals: 34,
  penaltyGoals: 0,
  isWinner: false,
};

const DublanCity = {
  team: Team__DublanCity,
  playingPlayers: [],

  goals: 61,
  penaltyGoals: 0,
  isWinner: false,
};

const IrrigacionAgricola = {
  team: Team__IrrigacionAgricola,
  playingPlayers: [],

  goals: 49,
  penaltyGoals: 0,
  isWinner: false,
};

const Potros = {
  team: Team__Potros,
  playingPlayers: [],

  goals: 18,
  penaltyGoals: 0,
  isWinner: false,
};

const Pistons = {
  team: Team__Pistons,
  playingPlayers: [],

  goals: 40,
  penaltyGoals: 0,
  isWinner: false,
};

export const Jornada1 = {
  jornadaPosition: 1,
  matches: [
    {
      team1: Joeles,
      team2: Adrianes,

      isCompleted: true,
      isPlaying: false,
      day: "Lunes",
      date: "2026-07-27",
      time: "11:00:00",
      location: "Centro Recreativo Lebaron",
    },
    {
      team1: PecanBros,
      team2: FlintTropics,

      isCompleted: true,
      isPlaying: false,
      day: "Lunes",
      date: "2026-07-27",
      time: "12:00:00",
      location: "Centro Recreativo Lebaron",
    },
    {
      team1: Llamas,
      team2: UTPaquime,

      isCompleted: true,
      isPlaying: false,
      day: "Lunes",
      date: "2026-07-27",
      time: "14:00:00",
      location: "Centro Recreativo Lebaron",
    },
    {
      team1: DublanCity,
      team2: IrrigacionAgricola,

      isCompleted: true,
      isPlaying: false,
      day: "Lunes",
      date: "2026-07-27",
      time: "15:00:00",
      location: "Centro Recreativo Lebaron",
    },
    {
      team1: Potros,
      team2: Pistons,

      isCompleted: true,
      isPlaying: false,
      day: "Lunes",
      date: "2026-07-27",
      time: "16:00:00",
      location: "Centro Recreativo Lebaron",
    }
  ],
};
